// ** React Imports
import { useRef, useEffect, useState } from 'react'
import GoogleMapReact from 'google-map-react'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Third Party Components
import PerfectScrollbarComponent from 'react-perfect-scrollbar'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import CustomAvatar from 'src/@core/components/mui/avatar'

import Image from 'next/image'

import dayjs from 'dayjs'

import { Modal, Spin } from 'antd'

import byteConversion from 'src/utils/byteConversion'

import { useDispatch, useSelector } from 'react-redux'
import { selectChat, loadingStatus } from 'src/store/apps/messenger'

import {
  switchUser,
  setPerViewImage,
  fetchChatsContacts,
  removeSelectedChat
} from 'src/store/apps/we-chat'
import { useTranslation } from 'src/utils/i18n'
import NoData from 'src/components/NoData'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

const AnyReactComponent = ({ text }) => (
  <div className=' '>
    <div className='relative flex '>
      <div className='absolute w-[180px] h-[40px] -mt-8 -ml-[70px] text-[13px] flex items-center text-center text-[#4d5976] text-opacity-90 font-[500] bg-white rounded-lg'>
        {text}
      </div>
      <div className='absolute flex items-center justify-center'>
        <Icon icon='material-symbols:location-on-rounded' width={50} height={50} className='text-[#FF5252]'></Icon>
      </div>
    </div>
  </div>
)

const MessagesLog = props => {
  // ** Props
  const { hidden, advanced } = props

  const data = useSelector(state => state.Messenger.selectedMessage)
  const store = useSelector(state => state.Messenger)

  const dispatch = useDispatch()

  const [flag, setFlag] = useState(false)

  const { t } = useTranslation('common')

  // ** Ref
  const chatArea = useRef(null)

  // ** Scroll to chat bottom
  const scrollToBottom = () => {
    if (chatArea.current) {
      if (hidden) {
        // @ts-ignore
        chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER

        // chatArea.current.scrollTop = Number.MAX_SAFE_INTEGER
      } else {
        // @ts-ignore
        chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER
      }
    }
  }

  // 记录首次加载
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  useEffect(() => {
    if (data && data.selected && data.selected.length <= 50) {
      scrollToBottom()
      setIsFirstLoad(false)
    } else {
      if (hidden) {
        // @ts-ignore
        chatArea.current._container.scrollTop = 20
      } else {
        // @ts-ignore

        chatArea.current._container.scrollTop = 20
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ** Renders user chat
  const renderChats = () => {
    if (data.selected.length == 0) {
      return (
        <div
          style={{
            background: '#F5F5F5',
            fontSize: '26px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#666',
            height: '100%'
          }}
        >
          <NoData />
        </div>
      )
    }

    return data.selected.map((item, index) => {
      const isSender = item.isFromMe

      const itemDate = dayjs(Number(item.date))
      const currentDate = dayjs()

      let time

      if (itemDate.isSame(currentDate, 'year')) {
        if (itemDate.isSame(currentDate, 'day')) {
          time = itemDate.format('HH:mm')
        } else {
          time = itemDate.format('MM-DD HH:mm')
        }
      } else {
        time = itemDate.format('YY-MM-DD HH:mm')
      }

      return (
        <>
          <Box
            key={item.PK + item.date + 1}
            className='row-item'
            sx={{
              display: 'flex',
              flexDirection: !item.isFromMe ? 'row' : 'row-reverse'
            }}
          >
            <Box
              className='chat-body'
              sx={{ maxWidth: ['calc(100% - 5.75rem)', '75%', '65%'], minWidth: '74px', position: 'relative' }}
              style={{
                maxWidth: item.messageType === 1 ? '100%' : '',
                width: item.messageType === 1 ? '100%' : ''
              }}
            >
              <Box key={index} sx={{ '&:not(:last-of-type)': { mb: 3.5 } }}>
                <div className='' style={{ display: 'flex', flexDirection: 'column' }}>
                  {store.members.length > 0 && item.messageType === 0 ? (
                    <span style={{ color: '#9ca3af', fontSize: '13px', marginBottom: '-6px' }}>
                      {store.members.find(row => row.uid == item.sender)
                        ? store.members.find(row => row.uid == item.sender).name
                        : ''}
                    </span>
                  ) : null}

                  <Box
                    sx={{
                      borderRadius: 1,
                      p: theme => theme.spacing(0, 2),
                      ml: isSender ? 'auto' : undefined,
                      borderTopLeftRadius: !isSender ? 0 : undefined,
                      borderTopRightRadius: isSender ? 0 : undefined,
                      color: isSender ? 'black' : 'text.primary',
                      backgroundColor: isSender ? '#D1FAE5' : '#ffffff',
                      mb: 4.4,
                      mt: 2,
                      boxShadow: item.messageType === 1 ? 'unset' : 1,
                      width: item.messageType === 1 ? '100%' : 'fit-content',
                      paddingTop: item.messageType == '0' && !item.messageType && item.text != '' ? '10px' : null,
                      paddingLeft: item.messageType == '0' && !item.messageType && item.text != '' ? '10px' : null,
                      paddingRight: item.messageType == '0' && !item.messageType && item.text != '' ? '10px' : null,
                      paddingBottom: item.messageType == '0' && !item.messageType && item.text != '' ? '6px' : null
                    }}
                  >
                    {(() => {
                      try {
                        if (!item.isAttachment) {
                          if (item.messageType === 0) {
                            return (
                              <div>
                                <div>
                                  <span
                                    className='chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box'
                                    style={{
                                      display: 'inline-block',
                                      wordBreak: 'break-all',
                                      maxWidth: '400px',
                                      overflow: 'hidden'
                                    }}
                                  >
                                    {item.text}
                                  </span>
                                </div>
                                <div
                                  className='absolute bottom-0 right-0'
                                  style={{
                                    width: '120px',
                                    left: !item.isFromMe ? '0' : 'unset',
                                    right: item.isFromMe ? '0' : 'unset'
                                  }}
                                >
                                  <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                    <p
                                      className={`text-[#9CA3AF] text-[0.6rem] ${item.isFromMe ? 'flex justify-end' : 'flex justify-start'
                                        }`}
                                    >
                                      {time}
                                    </p>
                                  </h2>
                                </div>
                              </div>
                            )
                          }
                        } else {
                          // 音频
                          if (typeof item.attachment.type === 'AUDIO') {
                            return (
                              <>
                                {item.attachment.expiredAt > 0 || new Date() > new Date(item.attachment.expiredAt) ? (
                                  <audio controls>
                                    <source src={'https://cos.spyx.com/' + item.attachment.url} type='audio/mpeg' />
                                    <embed
                                      height='50'
                                      width='100'
                                      src={'https://cos.spyx.com/' + item.attachment.url}
                                    ></embed>
                                  </audio>
                                ) : (
                                  <Icon icon='ic:baseline-broken-image' color='#494949' style={{ fontSize: '80px' }} />
                                )}
                              </>
                            )
                          } else if (item.attachment.type === 'IMAGE') {
                            return (
                              <div className=' flex p-2 chat_box'>
                                <div>
                                  <span className='font-semibold text-[0.8rem] text-black text-opacity-80'>
                                    {item.attachment.expiredAt > 0 ||
                                      new Date() > new Date(item.attachment.expiredAt + '000') ? (
                                      <Image
                                        src={'https://cos.spyx.com/' + item.attachment.url}
                                        alt='Picture of the author'
                                        width={150}
                                        height={150}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          dispatch(
                                            setPerViewImage({
                                              open: true,
                                              url: `https://cos.spyx.com/${item.attachment.url}`
                                            })
                                          )
                                        }}
                                      />
                                    ) : (
                                      <Icon
                                        icon='ic:baseline-broken-image'
                                        color='#494949'
                                        style={{ fontSize: '80px' }}
                                      />
                                    )}
                                  </span>
                                </div>
                                <div className='absolute  bottom-0 right-0 '>
                                  <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                    <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                  </h2>
                                </div>
                              </div>
                            )
                          } else if (item.attachment.mimeType === 'audio/mp4') {
                            return (
                              <div className=' flex p-2 chat_box'>
                                <div>
                                  <span className='font-semibold text-[0.8rem] text-black text-opacity-80'>
                                    {item.attachment.expiredAt > 0 ||
                                      new Date() > new Date(item.attachment.expiredAt) ? (
                                      <video
                                        controls={true}
                                        autoPlay={false}
                                        id='video'
                                        preload='none'
                                        loop={false}
                                        muted={false}
                                        poster={'https://cos.spyx.com/' + item.attachment.cover_url}
                                      >
                                        {t('can not be used Video')}
                                        <source src={'https://cos.spyx.com/' + item.attachment.url} type='video/mp4' />
                                        <source src='movie.ogg' type='video/ogg' />
                                      </video>
                                    ) : (
                                      <Icon
                                        icon='ic:baseline-broken-image'
                                        color='#494949'
                                        style={{ fontSize: '80px' }}
                                      />
                                    )}
                                  </span>
                                </div>
                                <div className='absolute bottom-0 right-0'>
                                  <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                    <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                  </h2>
                                </div>
                              </div>
                            )
                          } else if (item.attachment.type === ' LOCATION') {
                            return (
                              <div style={{ height: '270px', width: '270px' }}>
                                <GoogleMapReact
                                  bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_KEY }}
                                  defaultCenter={{
                                    lat: Number(item.attachment.latitude),
                                    lng: Number(item.attachment.longitude)
                                  }}
                                  defaultZoom={15}
                                >
                                  <AnyReactComponent
                                    lat={Number(item.attachment.latitude)}
                                    lng={Number(item.attachment.longitude)}
                                    text={item.attachment.label + item.attachment.poiname}
                                  />
                                </GoogleMapReact>

                                <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                  <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                                </h2>
                              </div>
                            )
                          } else if (item.attachment.type === 'XMA') {
                            return (
                              <div style={{ margin: '2px 4px' }}>
                                <div>
                                  <span
                                    className='chat_box font-semibold text-[0.8rem] text-black text-opacity-80 chat_box'
                                    style={{
                                      display: 'inline-block',
                                      wordBreak: 'break-all',
                                      maxWidth: '400px',
                                      overflow: 'hidden',
                                      display: 'flex'
                                    }}
                                  >
                                    <div>
                                      <p>{item.attachment.title}</p>
                                      <span style={{ fontSize: '12px', color: '#747474' }}>
                                        {item.attachment.subtitle}
                                      </span>
                                    </div>
                                  </span>
                                </div>
                                <div
                                  className='absolute bottom-0 right-0'
                                  style={{
                                    width: '120px',
                                    left: !item.isFromMe ? '0' : 'unset',
                                    right: item.isFromMe ? '0' : 'unset'
                                  }}
                                >
                                  <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                    <p className='text-[#9CA3AF] text-[0.6rem]'>{time}</p>
                                  </h2>
                                </div>
                              </div>
                            )
                          }
                        }
                      } catch (error) {
                        console.log(error)
                      }
                    })()}
                  </Box>
                </div>
              </Box>
            </Box>
          </Box>
          <Box className='row-item' key={item.PK + item.date + 2} style={{ color: 'red' }}>
            {item.messageType === 1 ? (
              <div className='chat_box' style={{ width: '100%' }}>
                <div style={{}}>
                  <p
                    style={{
                      display: 'inline-block',
                      overflow: 'hidden',
                      color: '#757C86',
                      textAlign: 'center',
                      width: '100%'
                    }}
                  >
                    {item.text}
                  </p>
                </div>
              </div>
            ) : null}
          </Box>
        </>
      )
    })
  }

  const [scroll, setScroll] = useState(0)

  useEffect(() => {
    if (scroll >= 100) {
      if (store.flag) return

      if (
        store.selectedMessage.selected.length == store.rightTotalCount ||
        store.selectedMessage.selected.length == 0
      ) return

      dispatch(loadingStatus())
      dispatch(selectChat())
    }
  }, [scroll])

  return (
    <>
      <Box
        sx={{
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px'
        }}
        className={`h-auto flex-1 ${advanced ? 'overflow-y-auto' : 'overflow-hidden'}`}
      >
        {hidden ? (
          <>
            {advanced ?
              <PerfectScrollbar
                ref={chatArea}
                options={{ wheelPropagation: false, suppressScrollX: true }}
                onScrollY={(e) => {
                  const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0)

                  if (!isFirstLoad && progress >= 75) {
                    setScroll(progress)
                  }
                }}
              >
                {store.flag ? (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Spin />
                  </div>
                ) : null}
                {renderChats()}
              </PerfectScrollbar>
              :
              renderChats()
            }
          </>
        ) : (
          <>
            {advanced ?
              <PerfectScrollbar
                ref={chatArea}
                options={{ wheelPropagation: false }}
                onScrollY={(e) => {
                  const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0)

                  if (!isFirstLoad && progress >= 75) {
                    setScroll(progress)
                  }
                }}
              >
                {store.flag ? (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Spin />
                  </div>
                ) : null}
                {renderChats()}
              </PerfectScrollbar>
              :
              renderChats()
            }
          </>
        )}
      </Box>{' '}
      <Modal
        title=''
        open={store.preViewImage.open}
        onCancel={() => {
          dispatch(
            setPerViewImage({
              open: false,
              url: ``
            })
          )
        }}
        width='540px'
        footer={[]}
        zIndex={1200}
      >
        <div style={{ padding: '14px' }}>
          <Image
            src={store.preViewImage.url}
            width={200}
            height={200}
            style={{ width: '460px', height: 'auto' }}
            alt='preview'
          ></Image>
        </div>
      </Modal>
    </>
  )
}

export default MessagesLog
